export type EventProps = Record<string, any>

function amp(): any | undefined {
  // Safely access amplitude on window
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (typeof window !== 'undefined' && (window as any).amplitude) || undefined
}

export function track(event: string, props: EventProps = {}): void {
  try {
    amp()?.track?.(event, { ...props, event_version: 1 })
  } catch {
    // no-op
  }
}

export function setUserId(id: string | null): void {
  try {
    amp()?.setUserId?.(id)
  } catch {
    // no-op
  }
}

export function setUserProps(props: EventProps): void {
  try {
    amp()?.setUserProperties?.(props)
  } catch {
    // no-op
  }
}

export function getTgContext(): EventProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const tg: any | undefined = (typeof window !== 'undefined' && (window as any).Telegram?.WebApp) || undefined
  const user = tg?.initDataUnsafe?.user
  const viewport = { w: window.innerWidth, h: window.innerHeight }
  return {
    tg_platform: tg?.platform ?? null,
    tg_language: user?.language_code ?? null,
    theme: tg?.colorScheme ?? (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'),
    is_expanded: !!tg?.isExpanded,
    viewport_w: viewport.w,
    viewport_h: viewport.h,
    start_param: tg?.initDataUnsafe?.start_param ?? null,
  }
}

export function identifyTelegramUser(userId: string): void {
  setUserId(userId)
  // Set stable context properties once
  setUserProps({
    ...getTgContext(),
  })
}
